import {IBuyFeatureLogic} from '@gongxigames/framework/slot/services/logic/buyFeature/IBuyFeatureLogic';
import {BuyFeatureType} from '@gongxigames/framework/slot';

export interface ILogicBuyFeatureFunctional<BuyFeatureT = BuyFeatureType> {
    getBuyFeature(): IBuyFeatureLogic<BuyFeatureT>;
}
